<template>
  <div class="page">
    <sunset-note-stats-query-bar v-slot="{ params, meta, query, currentUser }">
      <section>
        <h2>
          User stats for {{
            currentUser
                ? (currentUser.user_name || currentUser.name || ((currentUser.first_name || '') + ' ' + (currentUser.surname || '')).trim())
                : 'Select a user'
          }}
        </h2>

        <NoteStatsCsvButton mode="notes-user" :params="params" :query="query" />

        <!-- refactored: pass params/meta/query directly -->
        <PaginatedUserNotes
            :params="params"
            :meta="meta"
            :query="query"
        />
      </section>
    </sunset-note-stats-query-bar>
  </div>
</template>

<script>
import PaginatedUserNotes from './components/user_notes_detailed/user_notes_detailed.vue';
import loadingCube from 'loaders/record_loader.vue';
import SunsetNoteStatsQueryBar from 'pages/sunset/reports/notestats/components/shared/query_controls.vue';
import NoteStatsCsvButton from 'pages/sunset/reports/notestats/components/shared/csv_button.vue';

export default {
  name: 'sunset_user_notes_details',
  components: {
    NoteStatsCsvButton,
    SunsetNoteStatsQueryBar,
    loadingCube,
    PaginatedUserNotes,
  },
};
</script>

<style lang="scss">
</style>
